import { request, requestkind } from "./request"

var FileSaver = require('file-saver');

enum DownloadKind {
    DepositAgreement = "DepositAgreement",
    GuaranteeImplement = "GuaranteeImplement",
    CorpGuaranteeApply = "CorpGuaranteeApply",
    EptTemplate = "EptTemplate"
}

const download = (headers: any, blob: Blob) => {
    console.log(headers, blob)
    try {
        let fileName = headers
            ?.get('content-disposition')
            ?.split(';')[1]
            .split('filename=')[1];
        let fileNameUnicode = headers
            ?.get('content-disposition')
            ?.split('filename*=')[1];
        if (fileNameUnicode) {
            fileName = decodeURIComponent(fileNameUnicode.split("''")[1]);
        }
        FileSaver.saveAs(blob, fileName);
    } catch (error) {
        console.log('err in download', error)
        FileSaver.saveAs(blob, Date.now() + '.xlsx');
    }

}

const downloadStaticFile = async (downloadKind: DownloadKind) => {
    const { headers, blob } = await request(null, { fileKey: downloadKind }, requestkind.File.DownloadStaticFile)
    download(headers, blob)
    // const newBlob = new Blob([blob]);
    // const blobUrl = window.URL.createObjectURL(newBlob);
    // const link = document.createElement('a');
    // link.href = blobUrl;
    // link.setAttribute('download', `${downloadKind}.xlsx`);
    // link.click();
    // window.URL.revokeObjectURL(blob);
}

const downloadUploadedFile = async (fileid: string) => {
    const { headers, blob } = await request(null, { fileId: fileid }, requestkind.File.downloadUploadedFile)
    download(headers, blob)
}

export {
    downloadStaticFile,
    downloadUploadedFile,
    DownloadKind
}
